import { gql } from 'graphql-request';

import {
  FRAGMENT_PROPERTY_DETAILS_CORE,
  FRAGMENT_PROPERTY_DETAILS_PREVIEW,
} from './fragments/PropertyDetails.graphql';
import { FRAGMENT_PROPERTY_LOCATION } from './fragments/PropertyStateLocation.graphql';
import { FRAGMENT_MSA_PREVIEW } from './fragments';

export const QUERY_PROPERTY_STATE_PREVIEW_PR = gql`
  ${FRAGMENT_PROPERTY_LOCATION}
  ${FRAGMENT_PROPERTY_DETAILS_PREVIEW}
  ${FRAGMENT_MSA_PREVIEW}
  query PropertyStatePreviewPr($cerberusInput: CerberusInput!) {
    # HC INTERNAL
    lookup(id: $cerberusInput) {
      propertyDetails {
        hcAddressId
        location {
          ...PropertyLocation
        }
        pr {
          property {
            ...PropertyDetailsPreview
          }
        }
        msaDetails {
          ...MsaPreview
        }
      }
    }
  }
`;

export const QUERY_PROPERTY_STATE_CORE_PR = gql`
  ${FRAGMENT_PROPERTY_LOCATION}
  ${FRAGMENT_PROPERTY_DETAILS_CORE}
  ${FRAGMENT_MSA_PREVIEW}
  query PropertyStateCorePr($cerberusInput: CerberusInput!) {
    # HC INTERNAL
    lookup(id: $cerberusInput) {
      propertyDetails {
        hcAddressId
        location {
          ...PropertyLocation
        }
        pr {
          property {
            ...PropertyDetailsCore
          }
        }
        msaDetails {
          ...MsaPreview
        }
      }
    }
  }
`;
